export enum ColorInfoType {
  Paint,
  Metallic,
  Stain,
}
